module.exports = __webpack_public_path__ + "static/media/share.39224e24.svg";